<template>
  <component :is="layout"></component>
</template>

<script>
import Empty from './TheEmpty.vue';
import Main from './TheMainLayout.vue';

export default {
  name: 'TheDynamicLayout',
  components: {
    Empty,
    Main,
  },
  computed: {
    layout() {
      return this.userAuthenticated ? 'Main' : 'Empty';
    },
  },
};
</script>
